export enum LegalStatusEnum {
    OK = 'OK',
    OBSOLETE = 'OBSOLETE',
    KO = 'KO',
}
